import { render, staticRenderFns } from "./minuta.vue?vue&type=template&id=a38650fe&scoped=true&"
import script from "./minuta.vue?vue&type=script&lang=js&"
export * from "./minuta.vue?vue&type=script&lang=js&"
import style0 from "./minuta.vue?vue&type=style&index=0&id=a38650fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38650fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
